import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * Class to filter an Array of Items.
 *
 * @class EditorItemFilter
 * @param {Array|undefined} allowedItemTypes
 */
export default class EditorItemFilter {
    constructor(allowedItemTypes) {
        this.allowedItemTypes = allowedItemTypes ?? [];
    }

    /**
     *
     * @param {Array} types
     */
    setAllowedItemTypes(types) {
        this.allowedItemTypes = types;
    }

    /**
     * @param {Array} items
     *
     * @return {Array}
     */
    filterItems(items) {
        if (this.allowedItemTypes.length !== 0) {
            return items.filter(item => this.allowedItemTypes.includes(item.getType()));
        }

        return items;
    }
}

namespace('Ofcs.Editor.Item');
window.Ofcs.Editor.Item.EditorItemFilter = EditorItemFilter;
